module.exports = __webpack_public_path__ + "static/media/background.9a9ec6a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/modules/brand/brands/hmc/media/background.jpg
// module id = 848
// module chunks = 0